import { CurrentRoleData } from '~/modules/settings/_state/roleForm.state';
import { createQueryHook } from '~/shared/providers/api';

export interface ExternalRoleQueryParams {
  roleId: string;
}

export interface ExternalRoleQueryResult {
  role: CurrentRoleData | null;
}

export const useExternalRoleQuery = createQueryHook(
  'settings.customerPortal.role',
  (params: ExternalRoleQueryParams) => ({
    coreRole: {
      __args: { id: params.roleId },
      id: true,
      name: true,
      description: true,
      permissions: true,
      archived: true,
      timestamps: {
        updatedAt: true,
      },
    },
  }),
  {
    select: (data): ExternalRoleQueryResult => ({
      role: data?.coreRole
        ? {
            id: data.coreRole.id,
            name: data.coreRole.name,
            description: data.coreRole.description ?? null,
            permissions: data.coreRole.permissions ?? [],
            status: data.coreRole.archived ? 'archived' : 'active',
            updatedAt: data.coreRole.timestamps?.updatedAt ?? null,
            updatedBy: null,
          }
        : null,
    }),
  },
);
